import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ArgusSyncOptionEnum } from '../models/enums/argus-sync-option.enum';
import { ActionStageEnum } from '../modules/raci/models/enums/action-stage-enum';

/**
 * RACI Navigation service
 */
@Injectable({
  providedIn: 'root'
})
export class RaciNavigationService {

  /**
   * Show Raci Particicipants Event
   */
  _showRaciParicipantsSection = new BehaviorSubject<boolean>(false);

  /**
   * Update raci steps icon
   */
  _updateStepsIcon = new BehaviorSubject<boolean>(false);

  /**
   * Show or hide raci module
   */
  _showHideRaciModule = new BehaviorSubject<boolean>(false);

  /*
   Show Participants Assignment Template
  */
  _showParticipantsAssignment = new BehaviorSubject<boolean>(false);

  /*
    Save Project Participants
  */
  _onSaveProjectParticipants = new BehaviorSubject<boolean>(false);

  /*
    Group Portfolio Properties
  */
  _groupPortfolioProperties = new BehaviorSubject<string>('');

  /*
    Save approval
  */
  _onSaveApproval = new BehaviorSubject<boolean>(false);

  /**
   * Open report event
   */
  _openReport = new BehaviorSubject<boolean>(false);

  /**
   * Is row on kendo grid selected
   */
  _isRowSelected= new BehaviorSubject<boolean>(false);

  /**
   * Open preview for portfolio
   */
  _openPreviewDashboard = new BehaviorSubject<boolean>(false);

  /**
   * Click on close participants assignment
   */
  _onClickCloseParticipantsAssignment = new BehaviorSubject<boolean>(false);

  /**
   * Close participant assignment
   */
  _closeParticipantsAssignment = new BehaviorSubject<boolean>(true);

  /**
   * Click on close approval proccess
   */
  _onCloseRaci = new BehaviorSubject<boolean>(false);

  /**
   * Close approval proccess
   */
  _closeRaci = new BehaviorSubject<boolean>(false);

  /**
 * Sync Portfolio with Argus
 */
  _syncPortfolioWithArgus = new BehaviorSubject<boolean>(false);

  /**
* Sync with Valorem
*/
  _syncPortfolioWithVaorem = new BehaviorSubject<boolean>(false);

/**
* Show Sync with Argus icon
*/
  _showSyncWithArgus = new BehaviorSubject<boolean>(false);

  /**
* If tasks should be refreshed
*/
  refreshTasks = new BehaviorSubject<boolean>(false);

  /**
  * Show save approval icon
  */
  _showSaveApprovalIcon = new BehaviorSubject<boolean>(false);

  /**
   * Show Task Approval History icon
   */
  _showTaskApprovalHistoryIcon = new BehaviorSubject<boolean>(false);

  /**
   * Show Task Approval History dialog
   */
  _onDisplayTaskApprovalHistoryDialog = new BehaviorSubject<boolean>(false);

  /**
  * Show valorem history icon
  */
  _showValoremHistoryIcon = new BehaviorSubject<boolean>(false);

  /**
 * Show close valuation event dialog
 */
  _showCloseValuationEventDialog = new BehaviorSubject<boolean>(false);

  /**
* Show approval history dialog
*/
  _onDisplayApprovalHistory = new BehaviorSubject<boolean>(false);

  /**
* Show approval history icon
*/
  _onDisplayApprovalHistoryIcon = new BehaviorSubject<boolean>(false);

  /**
 * Save valuation event effective dates
 */
  _onSaveEffectiveDates = new BehaviorSubject<boolean>(false);

  /**
  * Hide user dashboard navigation icons
  */
  _onHideTopNavigationUserDashboardIcons = new BehaviorSubject<boolean>(false);

  /**
  * Hide raci navigation icons
  */
  _onHideTopNavigationIcons = new BehaviorSubject<boolean>(false);

  /**
   * Update publish to valorem active status
   */
  _updatePublishToValoremActiveStatus = new BehaviorSubject<boolean>(false);

  /**
   * On display publish to valorem
   */
  _onDisplayPublishToValorem = new BehaviorSubject<boolean>(false);

  /**
   * Show approve icon
   */
  _showApproveIcon = new BehaviorSubject<boolean>(false);

  /**
   * Show preview portfolio icon
   */
  _showPreviewPortfolioIcon = new BehaviorSubject<boolean>(false);

  /**
   * On row selection
   */
  _selectRow = new BehaviorSubject<boolean>(false);

  /**
   * Update sync with argus active status
   */
  _updateSyncWithArgusActiveStatus = new BehaviorSubject<boolean>(false);

  /**
   * On display project details
   */
  _displayProjectDetails = new BehaviorSubject<boolean>(false);

  /**
   * On show project details icon
   */
  _showProjectDetailsIcon = new BehaviorSubject<boolean>(false);

  /**
   * On hide approval history icon
   */
  _hideApprovalHistoryIcon = new BehaviorSubject<boolean>(false);

  /**
   * On steps reset
   */
  _stepsResetShouldConfirmDialog = new BehaviorSubject<boolean>(false);

  /**
   * On host reset
   */
  _hostResetShouldConfirmDialog = new BehaviorSubject<boolean>(false);

  /**
   * Selected argus sync option
   */
  _argusSyncOption: ArgusSyncOptionEnum;

  /**
   * Selected porfolio project id 
   */
  _projectId: number;

  /**
   * Selected porfolio project id 
   */
  _portfolioId: number;

  /**
  * Active Portfolio
  */
  private activePortfolio: any;

  /**
   * Active Valuation Event setup
   */
  private activeValuationEventSetup: any;

  /**
  * Show save Valuation Event Setup icon
  */
  _showSetupValuationEventSaveIcon = new BehaviorSubject<boolean>(false);

  /**
  * Is project closed indicator
  */
  _isProjectClosed = new BehaviorSubject<boolean>(false);

  /**
  * Show participants form
  */
  _showParticipantsForm = new BehaviorSubject<boolean>(false);

  /**
   * Show save valuation effective dates
   */
  _showSetupValuationEffectiveDatesSaveIcon = new BehaviorSubject<boolean>(false);

  /**
  * Is general task active
  */
  _isGeneralTaskActive = new BehaviorSubject<boolean>(false);

  /**
  * Is general task active
  */
  _isApprovalDialogDisplayed = new BehaviorSubject<boolean>(false);

  /**
  * Is approval clicked
  */
  _isApprovalClicked = new BehaviorSubject<boolean>(false);

  /**
* Set active portfolio
* @param portfolio Active portfolio
*/
  setActivePortfolio(portfolio: any): void {
    this.activePortfolio = portfolio;
  }

  /**
* Get active portfolio
*/
  getActivePortfolio(): any {
    return this.activePortfolio;
  }

  /**
* Trigger events for refreshing tasks
* @param refresh If tasks should be refreshed
*/
  onRefreshTasks(refresh: boolean): void {
    this.refreshTasks.next(refresh);
  }

  /**
   * Display participants section
   */
  showRaciParticipantsSection(value: boolean) {
    this._showRaciParicipantsSection.next(value);
  }

  /**
   * Retrive Participants Assignment
   */
  getParticipantsAssignment() {
    return this._showParticipantsAssignment;
  }

  /**
   * Emit show participants assignment event
   * @param value Emitted value
   */
  showParticipantsAssignment(value: boolean) {
    this._showParticipantsAssignment.next(value);
    this._onClickCloseParticipantsAssignment.next(false);
  }

  /**
   * Emit save project participants event
   */
  onSaveProjectParticipants() {
    this._onSaveProjectParticipants.next(true);
  }

  /**
  * Emit save valuation event effective start and end dates event
  */
  onSaveEffectiveDates(value: boolean) {
    this._onSaveEffectiveDates.next(value);
  }

  /**
   * Emit group portfolio properties event
   * @param value
   */
  groupPortfolioProperties(value: string) {
    this._groupPortfolioProperties.next(value);
  }

  /**
   * Emit open report event
   */
  openReport() {
    this._openReport.next(true);
  }

  /**
   * Subscribe to event if row is slected on kando grid
   */
  isRowSelected(): any {
    this._isRowSelected.subscribe(data => {
      return data;
    })
  }

  /**
   * Emit open preview dashboard event
   */
  openPreviewDashboard() {
    this._openPreviewDashboard.next(true);
  }

  /**
   * Emit event to close participant assignment
   */
  closeParticipantsAssignment(value: any) {
    this._onClickCloseParticipantsAssignment.next(value);
  }

  /**
   * Emit even on click close participant assingment
   */
  onCloseParticipantsAssignment(value: any) {
    this._closeParticipantsAssignment.next(value);
  }

  /**
   * Emit event on click close approval proccess
   */
  onCloseRaci() {
    this._onCloseRaci.next(true);
  }

  /**
   * Emit event to close approval proccess
   */
  closeRaci(value) {
    this._closeRaci.next(value);
  }

  /**
 * Emit event to hide/show icon for sync portfolio with argus
 */
  onSyncPortfolioWithArgus(display: boolean, option: number) {
    this._syncPortfolioWithArgus.next(display);
    this._argusSyncOption = option;
  }

  /**
* Emit event to hide/show icon for sync portfolio with valorem
*/
  onSyncWithValorem(display: boolean) {
    this._syncPortfolioWithVaorem.next(display);
  }

  /**
   * Display Sync with Argus icon
   */
  showSyncWithArgus(value: boolean) {
    this._showSyncWithArgus.next(value);
  }

  /**
   * Show save approval icon
   */
  showSaveApprovalIcon(value: boolean) {
    this._showSaveApprovalIcon.next(value);
  }

  /**
   * Display Task approval history icon
   */
  showTaskApprovalHistoryIcon(value: boolean) {
    this._showTaskApprovalHistoryIcon.next(value);
  }

  /**
   * Display Task approval history icon
   */
  showValoremHistoryIcon(value: boolean) {
    this._showValoremHistoryIcon.next(value);
  }

  /**
  * Display Task approval history dialog
  */
  onDisplayTaskApprovalHistoryDialog(value: boolean) {
    this._onDisplayTaskApprovalHistoryDialog.next(value);
  }

  /**
   * Show close valuation event dialog
   */
  showCloseValuationEventDialog(value: boolean) {
    this._showCloseValuationEventDialog.next(value);
  }

  /**
 * Show approval history dialog
 */
  onDisplayApprovalHistory(value: boolean) {
    this._onDisplayApprovalHistory.next(value);
  }

  /**
  * Show approval history icon
  */
  onDisplayApprovalHistoryIcon(value: boolean) {
    this._onDisplayApprovalHistoryIcon.next(value);
  }

  /**
   * Display save icon for Valuation Event setup
   */
  showSetupValuationEventSaveIcon(value: boolean) {
    this._showSetupValuationEventSaveIcon.next(value);
  }

  /**
   * Set active Valuation Event setup
   */
  setActiveValuationEventSetup(setup: any): void {
    this.activeValuationEventSetup = setup;
  }

  /**
* Get active Valuation Event setup
*/
  getActiveValuationEventSetup(): any {
    return this.activeValuationEventSetup;
  }

  /**
   * Set active Valuation Event setup
   */
  setIsProjectClosed(value: any) {
    this._isProjectClosed.next(value);
  }

  /**
   * Show the participants form
   * @param value
   */
  showParticipantsForm(value: any) {
    this._showParticipantsForm.next(value);
  }

  /**
   * Show setup valuation effective dates icon
   * @param value
   */
  showSetupValuationEffectiveDatesSaveIcon(value: any) {
    this._showSetupValuationEffectiveDatesSaveIcon.next(value);
  }

  /**
   * Hide top navigation user dashboard icons
   * @param value
   */
  hideTopNavigationUserDashboardIcons(value: any) {
    this._onHideTopNavigationUserDashboardIcons.next(value);
  }

  /**
   * Hide top navigation icons
   * @param value
   */
  hideTopNavigationIcons(value: any) {
    this._onHideTopNavigationIcons.next(value);
  }

  /**
   * Set active valuation event icons
   * @param task
   */
  setActiveValuationEventIcons(task: any) {
    if (task.taskActionStage === ActionStageEnum.Waiting) {
      this.showSetupValuationEventSaveIcon(true);
    }
  }

  /**
   * Set active valuation effective dates setup icons
   * @param task
   */
  setActiveValuationEffectiveDatesSetupIcons(task: any) {
    if (task.taskActionStage === ActionStageEnum.Waiting) {
      this.showSetupValuationEffectiveDatesSaveIcon(true);
    }
  }

  /**
   * Set active valorem icons
   */
  setActiveValoremIcons() {
    this.hideTopNavigationIcons(true);
    this.onDisplayApprovalHistoryIcon(true);
    this.showTaskApprovalHistoryIcon(true);
    this.hideTopNavigationUserDashboardIcons(false);
  }

  /**
   * Set active approval icons
   * @param task
   */
  setActiveApprovalIcons(task: any) {
    this.setTaskIconsInner(task);
  }

  /**
   * Set active argus icons
   */
  setActiveArgusIcons() {
    this.hideTopNavigationIcons(true);
    this.hideTopNavigationUserDashboardIcons(false);
  }

  /**
   * Set active argus sync icons
   */
  setActiveArgusSyncIcons() {
    this.hideTopNavigationIcons(true);
    this.hideTopNavigationUserDashboardIcons(false);
  }

  /**
   * Set active undefined task icons
   * @param task
   */
  setActiveUndeFinedTaskIcons(task: any) {
    this.setTaskIconsInner(task);
  }

  /**
   * Continue: Set task icons
   * @param task
   */
  private setTaskIconsInner(task: any) {
    if (task.taskActionStage === ActionStageEnum.Waiting) {
      this.showSaveApprovalIcon(true);
    }

    this.hideTopNavigationIcons(true);
    this.onDisplayApprovalHistoryIcon(true);
    this.showTaskApprovalHistoryIcon(true);
    this.hideTopNavigationUserDashboardIcons(false);
  }

  /**
   * Reset navigation icons
   */
  resetNavigationIcons() {
    this.hideTopNavigationIcons(false);
    this.hideTopNavigationUserDashboardIcons(true);
    this.onDisplayApprovalHistoryIcon(false);
    this.showSetupValuationEventSaveIcon(false);
    this.showSetupValuationEffectiveDatesSaveIcon(false);
    this.showSaveApprovalIcon(false);
    this.showTaskApprovalHistoryIcon(false);
  }

  /**
   * On update publish to valorem active status
   * @param value
   */
  onUpdatePublishToValoremActiveStatus(value: any) {
    this._updatePublishToValoremActiveStatus.next(value);
  }

  /**
   * On display publish to valorem
   * @param value
   */
  onDisplayPublishToValorem(value: any) {
    this._onDisplayPublishToValorem.next(value);
  }

  /**
   * On show approve icon
   * @param value
   */
  onShowApproveIcon(value: any) {
    this._showApproveIcon.next(value);
  }

  /**
   * On show preview portfolio icons
   * @param value
   */
  onShowPreviewPortfolioIcon(value: any) {
    this._showPreviewPortfolioIcon.next(value);
  }

  /**
   * On row selection
   * @param value
   */
  onSelectRow(value: any) {
    this._selectRow.next(value);
  }

  /**
   * On update sync with argus action status
   * @param value
   */
  onUpdateSyncWithArgusActiveStatus(value: any) {
    this._updateSyncWithArgusActiveStatus.next(value);
  }

  /**
   * On display project details
   * @param value
   */
  onDisplayProjectDetails(value: any) {
    this._displayProjectDetails.next(value);
  }

  /**
   * On show project details icon
   * @param value
   */
  onShowProjectDetailsIcon(value: any) {
    this._showProjectDetailsIcon.next(value);
  }

  /**
   * On hide approval history icon
   * @param value
   */
  onHideApprovalHistoryIcon(value: any) {
    this._hideApprovalHistoryIcon.next(value);
  }

  /**
   * On steps reset
   * @param value
   */
  onStepsResetShouldConfirmDialog(value: any) {
    this._stepsResetShouldConfirmDialog.next(value);
  }

  /**
   * On host reset
   * @param value
   */
  onHostResetShouldConfirmDialog(value: any) {
    this._hostResetShouldConfirmDialog.next(value);
  }

  /**
   * Set is general task active
   */
  isGeneralTaskActive(value: any) {
    this._isGeneralTaskActive.next(value);
  }

  /**
   * Show approval matrix dialog
   */
  showApprovalMatrixDialog(value: any) {
    this._isApprovalDialogDisplayed.next(value);
  }

  /**
   * Is approval clicked
   */
  isApprovalClicked(value: any) {
    this._isApprovalClicked.next(value);
  }

  /**
   * On show or hide raci module
   * @param value
   */
  onShowHideRaciModule(value: any) {
    this._showHideRaciModule.next(value);
  }

  /**
   * On update steps icon
   * @param value
   */
  onUpdateStepsIcon(value: any) {
    this._updateStepsIcon.next(value);
  }
}
